import React from "react";

export default function Title({ title, ...rest }) {
  return (
    <h2 className="text-center" {...rest}>
      {title}
    </h2>
  );
}
